export default __webpack_public_path__ + "assets/images/88e871988808c8c29779ee81775c17b2.png";